<template>
  <div>
    <mq-layout :mq="['mobile', 'tablet']" class="Mobile-Container">
      <img class="img" src="@/assets/progression.jpg">
      <div class="container">
        <div class="containerChild">
          <div class="details">
            <div class="boxTitle">
              <div class="TitleMobile">Masterclass</div>
              <div class="showMore" @click="goto('themeList')">Voir plus --></div>
            </div>
            <div class="masterClassMobile">
              <div v-for="masterclass of masterclasseMobile" :key="masterclass.id" class="tileMaster">
                <div @click="onTileClick(masterclass.id)" class="test">
                  <img :src="masterclass.tileImage" class="imgMasterclass">
                </div>
                <div class="ButtonContainer">
                  <div class="Button" @click="onTileClick(masterclass.id)">
                    {{ buttonLabel(masterclass.id) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="details">
            <div class="boxTitle">
              <div class="TitleMobile">Boutique</div>
              <div class="showMore" @click="goto('shop-list-bottles')">Voir plus --></div>
            </div>
            <div class="shopMobile">
              <div v-for="bottle of bottleItemsMobile" :key="bottle.id">
                <div class="productDetails" @click="openBottle(bottle.id)">
                  <img :src="bottle.image" class="shopImgMobile">
                  <div class="priceBottleMobile"> {{`${bottle.price} €`}}</div>
                  <div class="bottleTitleMobile">{{bottle.title}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="details" v-if="themesQuiz.length > 0">
            <div class="boxTitle">
              <div class="TitleMobile">Progression</div>
              <div class="showMore" @click="goto('userProgression')">Voir plus --></div>
            </div>
            <div class="boxProgressionMobile">
              <div v-for="theme in themesQuiz" :key="theme.id" class="vv-box-progression">
                <progress-circle v-if="successQuiz(theme.id)" :isLocked="false" :percentage="100" :color="themeColor(theme.id)" :image="badgeImage(theme)" :changeImgSuccess="true"></progress-circle>
                <progress-circle v-else :isLocked="false" :percentage="themePercentage(theme.id)" :color="themeColor(theme.id)" :image="badgeImage(theme)" :changeImgSuccess="false"></progress-circle>
                <h2>{{ theme.title }}</h2>
              </div>
            </div>
          </div>
          <div class="details" v-if="myTastingListMobile.length > 0">
            <div class="boxTitle">
              <div class="TitleMobile">Degustation</div>
              <div class="showMore" @click="goto('listTasting')">Voir plus --></div>
            </div>
            <div class="MobileDegustation">
              <div v-for="tasting in myTastingListMobile" :key="tasting.id" class="degustaionMobile">
                <tasting-list-item :id="tasting.id"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mq-layout>

    <mq-layout mq="desktop">
      <div class="Desktop-Container">
        <div class="spacer">
          <div  class="masterBox">
            <div class="title">
              MASTERCLASS
            </div>
            <div class="masterClass"  v-if="masterclasse.length > 0">
              <div v-for="masterclass of masterclasse" :key="masterclass.id" class="tileMaster">
                <div @click="onTileClick(masterclass.id)" class="test">
                  <img :src="masterclass.tileImage" class="imgMasterclass">
                </div>
                <div class="ButtonContainer">
                  <div class="Button" @click="onTileClick(masterclass.id)">
                    {{ buttonLabel(masterclass.id) }}
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <span class="loadingDonne">Chargement des données...</span>
              <Spinner />
            </div>
          </div>
          <div class="detail">
            <div class="buttonPlus" @click="goto('themeList')">
              Voir plus
            </div>
          </div>
        </div>

        <div class="spacer">
          <div class="boxProg">
            <div class="title">
              PROGRESSION
            </div>
            <div class="boxProgression" v-if="themesList.length > 0">
              <div v-for="theme in themesList" :key="theme.id" class="vv-box-progression">
                <progress-circle v-if="successQuiz(theme.id)" :isLocked="false" :percentage="100" :color="themeColor(theme.id)" :image="badgeImage(theme)" :changeImgSuccess="true"></progress-circle>
                <progress-circle v-else :isLocked="false" :percentage="themePercentage(theme.id)" :color="themeColor(theme.id)" :image="badgeImage(theme)" :changeImgSuccess="false"></progress-circle>
                <h2>{{ theme.title }}</h2>
              </div>
            </div>
            <div v-else>
              <span class="loadingDonne">Chargement des données...</span>
              <Spinner />
            </div>
          </div>
          <div class="detail">
            <div class="buttonPlus" @click="goto('userProgression')">
              Voir plus
            </div>
          </div>
        </div>

        <div class="spacer">
          <div class="box">
            <div class="title">
              MES DEGUSTATIONS
            </div>
            <div v-if="myTastingList.length > 0">
              <div v-for="tasting in myTastingList" :key="tasting.id" class="degustaion">
                <tasting-list-item :id="tasting.id" :small="true" />
              </div>
            </div>
            <div v-else-if="bottleItems.length > 0" class="shopBottle">
              <div>Vous n'avez pas encore acheté de vins</div>
              <div class="desktopShop">
                <product-bottle-responcive
                  v-for="bottle of bottleItems" :key="bottle.id"
                  :title="bottle.title"
                  :description="bottle.description"
                  :price="bottle.price"
                  :sold-out="bottle.soldOut"
                  :image="bottle.image"
                  :isTasting="false"
                  :small="true"
                  :contentful-id="bottle.details"
                  @click="openBottle(bottle.id)"
                  class="itemBottle"
                />
              </div>
            </div>
            <div v-else>
              <span class="loadingDonne">Chargement des données...</span>
              <Spinner />
            </div>
          </div>
          <div class="detail">
            <div :class="myTastingList.length > 0 ? 'buttonPlus' : 'showMoreShop' " @click="goto(selectRedirect())">
              Voir plus
            </div>
          </div>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
import _get from 'lodash/get'

import remoteConfigMixin from '@/mixins/remoteConfig'
import userMixin from '@/mixins/user'
import contentMixin from '@/mixins/content'

import VvCategoryCard from '@/components/common/VvCategoryCard'
import { mapGetters } from 'vuex'
import TastingListItem from '@/components/tasting/TastingListItem'
import ProgressCircle from '@/components/userAccount/ProgressCircle'
import { getThemePercentageQuiz, getThemeColor } from '@/helpers/userCompletion'
import { contentHasQuiz } from '@/store/modules/quiz/actions'
import badgeMixin from '@/mixins/badge'
import ContentTile from '@/components/masterclass/ContentTile'
import { getThemePercentage } from '@/helpers/userCompletion'
import Spinner from '@/components/layout/Spinner'
import shopMixin from '@/mixins/shop'
import ProductBottleResponcive from '@/components/shop/ProductBottleResponcive'


export default {
  name: 'Home',
  mixins: [remoteConfigMixin, userMixin, contentMixin, badgeMixin, shopMixin],
  components: {
    VvCategoryCard,
    TastingListItem,
    ProgressCircle,
    ContentTile,
    Spinner,
    ProductBottleResponcive
  },
  data() {
    return {
      TastingList: []
    }
  },
  computed: {
    bottleItemsMobile() {
      const bottles = []
      let alreadyPushed = []
      for (const bottle of this.bottles) {
        if (alreadyPushed.indexOf(bottle.id) == -1) {
          const splitTitle = bottle.title.split('||')
          const title = splitTitle[0]
          const description = splitTitle[1]

          const base = {
            title,
            id: bottle.id
          }
          
          bottles.push(
            Object.assign({}, base, {
              description,
              price: Number(bottle.variants[0].price),
              soldOut: !bottle.variants[0].available,
              contentfulId: bottle.variants[0].sku,
              image: bottle.images[0].src,
              details: this.getBottleById(bottle.variants[0].sku)
            })
          )
          alreadyPushed.push(bottle.id)
        }
      }
      return bottles
    },
    bottleItems() {
      if (this.bottleItemsMobile.length > 0) {
        this.bottleItemsMobile.length = 2
      }
      return this.bottleItemsMobile
    },
    masterclassImage() {
      const images = {
        female: 'masterclass_female.jpg',
        male: 'masterclass_male.jpg',
        unknow: 'masterclass_couple.jpg'
      }

      if (!this.user) return images.unknow

      return images[this.user.gender || 'unknow']
    },
    ...mapGetters({ getTastings: 'getTastings', themes: 'getThemes' , themeId: 'getThemeById', getBottleById: 'getBottleById'}),
    themesQuiz() {
      return this.themes.filter(el => this.hasQuiz(el.id) == true
        && this.hasAccessToContent(el.id) == true)
    },
    themesList() {
      if(this.themesQuiz.length > 0) {
        this.themesQuiz.length = 4
      }
      return this.themesQuiz
    },
    discoverRegionMasterclasses() {
      if (this.themes.length > 0) {
        return this.sortMasterclassesByStatus(this.themes
        .filter(el => el && this.themeId(el.id) && this.themeId(el.id).discoverRegion)
        // .map(el => this.getThemeById(el.id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order))
      }
      return []
    },
    masterclasse() {
      if (this.discoverRegionMasterclasses.length > 0) {
        this.discoverRegionMasterclasses.length = 4 
      }
      return this.discoverRegionMasterclasses
    },
    masterclasseMobile() {
      return this.discoverRegionMasterclasses
    },
    myTastingListMobile() {
      let pushElemId = []
      let themes = this.themes.filter(t => t.tastings.length > 0 && this.hasAccessToContent(t.id))
      if (themes.length <= 0) return this.TastingList
      themes.forEach(theme => {
        let tastings = this.getTastings.filter(t => Object.values(_.mapValues(theme.tastings, 'id')).includes(t.id))

        for (let x = 0; tastings.length > 0 && x < tastings.length; x +=1) {
          if (x == 2) break
          if (pushElemId.indexOf(tastings[x].id) == -1) {
            this.TastingList.push(tastings[x])
            pushElemId.push(tastings[x].id)
          }
        }
      })
      return this.TastingList
    },
    myTastingList() {
      if (this.myTastingListMobile.length > 0) {  
        this.myTastingListMobile.length = 2
      }
      return this.myTastingListMobile
    }
  },
  methods: {
    selectRedirect() {
      return (this.myTastingList.length > 0 ? 'listTasting' : 'shop-list-bottles')
    },
    LoadingTest() {
      return (this.masterclasse.length > 0 && this.themesList.length > 0 && (this.myTastingList.length > 0 || this.bottleItems.length > 0)) ? true : false
    },
    openBottle(bottleId) {
      this.$router.push({
        name: 'shop-full-bottle',
        params: {
          productId: bottleId
        }
      })
    },
    onTileClick(id) {
      if (this.isLocked(id)) {
        return this.$router.push({
          name: 'shop-item',
          params: {
            type: 'masterclass',
            productId: id
          }
        })
      }

      this.$router.push({ name: 'theme', params: { themeId: id } })
    },
    themeHasBadge(themeId) {
      return this._getBadgeFromMasterclass(themeId)
    },
    badgeImage(theme) {
      let badge = this._getBadgeFromMasterclass(theme.id)
      return badge ? badge.image : theme.tileImage
    },
    hasQuiz(themeId) {
      return contentHasQuiz('masterclass', themeId, this.$store.state)
    },
    successQuiz(themeId) {
      let badge = this.themeHasBadge(themeId)
      // Check that the masterclass badge is in the acquired badges
      return this.hasQuiz(themeId) && badge && this.acquiredBadges.indexOf(badge.id) > -1 ? true : false
    },
    themePercentage(themeId) {
      return getThemePercentageQuiz(themeId)
    },
    themeColor(themeId) {
      return getThemeColor(themeId)
    },
    goto(routeName) {
      this.$router.push({ name: routeName })
    },
    sortMasterclassesByStatus(mc) {
      // 1. Masterclass started
      // 2. Masterclass with access
      // 3. Free masterclass
      // 4. Locked masterclass
      // 5. Available soon
      return mc.sort((a, b) => {
        if (a.author && a.author.fullName !== 'PENDING' && b.author && b.author.fullName === 'PENDING') return -1
        else if (a.author && a.author.fullName === 'PENDING' && b.author && b.author.fullName !== 'PENDING') return 1
        else {
          if (this.hasAccessToContent(a.id) && !this.hasAccessToContent(b.id)) {
            return -1
          } else if (!this.hasAccessToContent(a.id) && this.hasAccessToContent(b.id)) {
            return 1
          } else {
            if (getThemePercentage(a.id) > getThemePercentage(b.id)) return -1
            else if (getThemePercentage(a.id) < getThemePercentage(b.id)) return 1
            else {
              if (a.premium && !b.premium) return -1
              else if (!a.premium && b.premium) return 1
              else return 0
            }
          }
        }

        return 0
      })
    },
    masterclass(id) {
      return this.getThemeById(id)
    },
    background(id) {
      return `url(${this.masterclass(id).tileImage})`
    },
    isLocked(id) {
      return !this.hasAccessToContent(id)
    },
    completion(id) {
      return getThemePercentage(id)
    },
    buttonLabel(id) {
      if(this.completion(id) > 0 && !this.isLocked(id))
        return this.t('continue')
      else if (this.isLocked(id))
        return this.t('checkMore')
      else return this.t('begin')
    },
    t(key, params) {
      return this.$t(`masterclass-content-tile.${key}`, params)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.spacer {
  margin: 70px 0;
}
.showMoreShop {
  margin-top: -10px;
  cursor: pointer;
  padding: 5px 25px;
  background-color: #F9FAFF;
  border-radius: 30px;
  box-shadow: 2px 3px 6px #b0b4cb;
  &:hover {
    box-shadow: 2px 6px 8px #b0b4cb;

  }
}
.itemBottle {
  margin-bottom: 15px;
}
.desktopShop {
  width: 390px;
}
.loadingDonne {
  font-size: 25px;
  margin: 10px;
}
.showMore{
  font-size: 10px;
}
.details{
  display: flex;
  flex-direction: column;
}
.boxTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.TitleMobile {
  font-size: 20px;
  font-weight: 700;
}
.containerChild {
  padding: 10px 0px 0px 10px;
  margin: 10px 10px 100px 10px;
}
.container {
  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 0px 0px;
  background-color: #fff;
  margin-top: -20px;
  width: 100%;
  height: 100%;
  float: left;
}
.MobileDegustation {
  display: flex;
  flex-direction: row;
  overflow: auto;
}
.img{
  display: block;
  float: left;
  background-color: rgb(26, 39, 14);
  width: 100%;
  height: 180px;
}
.priceBottleMobile{
  padding: 7.5px 40px;
  background-color: $primary;
  color: white;
  border-radius: 23px;
  font-size: 14px;
  text-transform: uppercase;
  margin-top: -15px;
  margin-bottom: 5px;
  font-weight: bold;
}
.priceBottle{
  // width: 20px;
  padding: 7.5px 50px;
  background-color: $primary;
  color: white;
  border-radius: 23px;
  font-size: 14px;
  text-transform: uppercase;
  margin-top: -15px;
  margin-bottom: 5px;
  font-weight: bold;
}
.bottleTitleMobile{
  font-weight: 700;
  font-size: 15px;
}
.bottleTitle{
  font-weight: 700;
  font-size: 20px;
}
.productDetails{
  margin: 20px;
  align-items: center;
  align-content: center;
  display: flex;
  flex-direction: column;
}
.shopImgMobile{
  width: 180px;
  height: auto;
  border-radius: 23px;
}
.shopImg{
  width: 250px;
  height: auto;
  border-radius: 23px;
}
.shopBottle{
  display: flex;
  flex-direction: column;
  text-align: center;
}
.Button {
  cursor: pointer;
  padding: 7px 0px;
  background-color: $primary;
  font-weight: bold;
  color: white;
  border-radius: 23px;
  font-size: 12px;
  text-transform: uppercase;
  margin-top: 7px;
}
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}
.masterBox{
  border-radius: 30px;
  background-color: #F9FAFF;
  box-shadow: 2px 3px 6px #b0b4cb;
  padding: 30px;
  width: 390px;
  height: 740px;
  text-align: center;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
}
.test{
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 80%;
  display: flex;
  align-content: center;
  text-align: center;
}
.tileMaster{
  width: 175px;
  height: auto;
  margin: 25px 10px 10px;
  text-align: center;
}
.titleMaster{
  position: absolute;
  top: 50px;
  left: 0px;
  color: #ffff;
  font-size: 25px;
  font-weight: 700;
}
.imgMasterclass{
  border-radius: 20px;
  width: 175px;
  height: auto;
}
.shopMobile {
  display: flex;
  flex-direction: row;
  overflow: auto;
}
.masterClassMobile {
  display: flex;
  flex-direction: row;
  overflow: auto;
}
.masterClass {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.boxProg{
  text-align: center;
  border-radius: 30px;
  background-color: #F9FAFF;
  box-shadow: 2px 3px 6px #b0b4cb;
  padding: 30px;
  height: 740px;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
}
.boxProgressionMobile {
  overflow: auto;
  display: flex;
  flex-direction: row;
  text-align: center;
}
.boxProgression{
  display: flex;
  flex-wrap: wrap;
  height: auto;
  width: 500px;
  justify-content: center;
}
.vv-box-progression{
  max-width: 200px;
  margin: 40px 10px 0px 10px;
  // margin-top: 40px;
}
.degustaion:first-child {
  margin-bottom: 30px;
}

.degustaionMobile {
  margin: 20px 10px;
}
.buttonPlus {
  margin-top: -10px;
  cursor: pointer;
  padding: 5px 25px;
  background-color: #F9FAFF;
  border-radius: 30px;
  box-shadow: 2px 3px 6px #b0b4cb;
  &:hover {
    box-shadow: 2px 6px 8px #b0b4cb;

  }
}
.detail{
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  // height: 100%;
}
.box{
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  background-color: #F9FAFF;
  align-items: center;
  padding: 30px 50px;
  height: 740px;
  width: 390px;
  box-shadow: 2px 3px 6px #b0b4cb;
  text-align: center;
  flex-direction: column;
  display: flex;
  justify-content: flex-start
}
.title{
  font-weight: 900;
  font-size: 25px;
  height: 30px;
}
.Mobile-Container {
  // padding: 15px;
  // flex-wrap: wrap;
  // flex: 1;
  // display: flex;
  align-items: center;
  // justify-content: space-evenly;
}
.loading {
  width: 100%;
  height: 100%;
}
.Desktop-Container {
  margin-top: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex: 1;
}
</style>
